import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchChangelog: ['entity_name', 'resource_id', 'query'],
    fetchChangelogSuccess: ['items'],
    fetchChangelogFailure: ['error'],
});


export const ChangelogTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    items: [],
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch work order actions
    [Types.FETCH_CHANGELOG]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            items: [],
        };
    },

    [Types.FETCH_CHANGELOG_SUCCESS]: (state, {items}) => {
        return {
            ...state,
            items,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_CHANGELOG_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            items: [],
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/ChangelogRedux.js